<template>
  <v-reports v-if="access.report_accaunt" v-bind:update="update" Consumption>
    <template #header>
      <v-card>
        <v-card-text>
          <v-layout row>
            <v-flex md6 sm12 xs12 px-3>
              <div>{{ $t(`cash`) }}</div>
              <p class="display-1 text--primary text-center">
                {{ data.all_cash_actual.toLocaleString() }}
              </p>
            </v-flex>
            <v-flex md6 sm12 xs12 px-3>
              <div>{{ $t(`card`) }}</div>
              <p class="display-1 text--primary text-center">
                {{ data.all_card_actual.toLocaleString() }}
              </p>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex md6 sm12 xs12 px-3>
              <div>{{ $t(`all_cash`) }}</div>
              <p class="display-1 text--primary text-center">
                {{ data.all_cash.toLocaleString() }}
              </p>
            </v-flex>
            <v-flex md6 sm12 xs12 px-3>
              <div>{{ $t(`all_card`) }}</div>
              <p class="display-1 text--primary text-center">
                {{ data.all_card.toLocaleString() }}
              </p>
            </v-flex>
          </v-layout>
          <v-divider style="margin-bottom: 20px" />
          <p
            class="text-center"
            style="margin-bottom: 10px; margin-right: 250px; color: black"
          >
            {{ $t("consumption") }}
          </p>

          <v-divider style="margin-bottom: 50px" />

          <v-layout row>
            <v-flex md6 sm12 xs12 px-3>
              <div>{{ $t(`fees`) }}</div>
              <p class="display-1 text--primary text-center">
                {{ data.fees.toLocaleString() }}
              </p>
            </v-flex>
            <v-flex md6 sm12 xs12 px-3>
              <div>{{ $t(`one_time_fees`) }}</div>
              <p class="display-1 text--primary text-center">
                {{ data.one_time_fees.toLocaleString() }}
              </p>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6 sm12 xs12 px-3>
              <div>{{ $t(`salary`) }}</div>
              <p class="display-1 text--primary text-center">
                {{ data.salary.toLocaleString() }}
              </p>
            </v-flex>
            <v-flex md6 sm12 xs12 px-3>
              <div>{{ $t(`company_to_fees`) }}</div>
              <p class="display-1 text--primary text-center">
                {{ data.company_to_fees.toLocaleString() }}
              </p>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </template>
  </v-reports>
  <error404 v-else></error404>
</template>
<script>
export default {
  name: "ReportsConsumption",
  data: () => ({
    params: {},
    access: null,
    data_loading: false,
    data: {
      all_cash: 0,
      all_card: 0,
      all_cash_actual: 0,
      all_card_actual: 0,
      fees: 0,
      one_time_fees: 0,
      salary: 0,
      company_to_fees: 0,
    },
  }),
  methods: {
    async update(params) {
      this.data_loading = true;
      const start_date = new Date(params.start_date).getTime();
      const end_date = new Date(params.end_date).getTime();
      const res = this.$communicator.then(
        this,
        await this.$communicator("report_consumption", {
          arguments: [start_date, end_date],
          params: {
            services: params.service != "" ? params.service : "",
            employees: params.employee._id != "" ? params.employee._id : "",
          },
        })
      );
      if (res) {
        this.data = res;
      }
    },
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
